import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { Country } from '@/modules/predefined/models/Country';
import { Contact } from '@/modules/contact/models/Contact';

export class ContactCountryResidency extends BaseEntityModel {
  id: number | null;
  contactId: number | null;
  countryId: number | null;
  insuranceNumber: string | null;
  hasRequestedBenefits: boolean | null;
  country?: Relationship<Country>;
  contact?: Relationship<Contact>;

  constructor(model: Partial<ContactCountryResidency> = {}) {
    super(model);

    this.id = model.id ?? null;
    this.contactId = model.contactId ?? null;
    this.countryId = model.countryId ?? null;
    this.insuranceNumber = model.insuranceNumber ?? null;
    this.hasRequestedBenefits = model.hasRequestedBenefits ?? null;

    this.country = Country.mapModelOrNull(model.country) ?? undefined;
    this.contact = Contact.mapModelOrNull(model.contact) ?? undefined;
  }
}
